import React from 'react';
import { MessageCircle } from 'lucide-react';
import styled from 'styled-components';

// Styled components
const ChatContainer = styled.div`
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 1000;

  @media (min-width: 992px) {
    bottom: 20px; // Original position for desktop screens
  }
`;

const ChatButton = styled.div`
  background-color: #25D366;
  border-radius: 50%;
  padding: 8px; // Slightly smaller padding
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #128C7E;
  }

  @media (min-width: 992px) {
    padding: 10px; // Original size for desktop screens
  }
`;

const WhatsAppChat = () => {
  // WhatsApp number (international format)
  const phoneNumber = '';
  
  // Pre-defined message (optional)
  const message = encodeURIComponent('Hello, I need some assistance.');

  // WhatsApp chat link
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  const openWhatsAppChat = () => {
    window.open(whatsappLink, '_blank');
  };

  return (
    <ChatContainer>
      <ChatButton onClick={openWhatsAppChat}>
        <MessageCircle size={24} color="white" />
      </ChatButton>
    </ChatContainer>
  );
};

export default WhatsAppChat;